import { useEffect } from 'react';
import { node } from 'prop-types';
import useSystemTime from '../../stores/SystemTimeStore';
import useIsPrinting from '../../utilities/PrintUtilities';

export default function AppSystemTimeProvider(props) {
    const { children } = props;
    const isPrinting = useIsPrinting();
    const [, /* not needed */ systemTimeActions] = useSystemTime();

    // Initialize the session for the application.
    useEffect(() => {
        systemTimeActions.syncSystemTime(!isPrinting);
    }, [systemTimeActions, isPrinting]);

    return children;
}

AppSystemTimeProvider.propTypes = {
    children: node,
};

AppSystemTimeProvider.defaultProps = {
    children: null,
};
